import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { type sizeOfPortfolio } from './constants/UnitOptions';

const stepVariant = {
  1: 'units',
  2: 'register',
};

export type StateUSA = {
  id: number;
  label: string;
  value: string;
  isEastCoast?: boolean;
};

export type UserFullDTO = {
  data: { data: UserFull };
  status: number;
};

type UserFull = UnitsData | RegisterData | Extra;

type Extra = {
  redirectUri: string;
  id: string;
};

export type UnitsData = {
  sizeOfPortfolio: sizeOfPortfolio | undefined;
  ownedUnits?: number;
  state: StateUSA | undefined;
  email?: string; // For AB test variant
};

export type RegisterData = {
  firstName: string;
  lastName: string;
  email: string;
  companyName?: string;
  phoneNumber?: string;
  propertyLLC?: string;
  state?: StateUSA; // For AB test variant
};

type SetDataType = { step: 1; data: UnitsData } | { step: 2; data: RegisterData };

export type Store = {
  units: UnitsData | null;
  register: RegisterData | null;
  emailError: string | null; // For handling email validation errors across steps
  setData: ({ step, data }: SetDataType) => void;
  setEmailError: (error: string | null) => void;
  clearEmailError: () => void;
};

const useFormStore = create(
  devtools<Store>((set) => ({
    units: {
      sizeOfPortfolio: undefined,
      email: undefined,
      state: {
        id: 0,
        label: '',
        value: '',
      },
    },
    register: {
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      phoneNumber: '',
      propertyLLC: '',
      agree: true,
      state: {
        id: 0,
        label: '',
        value: '',
      },
    },
    emailError: null,
    setData: ({ step, data }) =>
      set((state) => ({
        ...state,
        [stepVariant[step]]: data,
      })),
    setEmailError: (error) =>
      set((state) => ({
        ...state,
        emailError: error,
      })),
    clearEmailError: () =>
      set((state) => ({
        ...state,
        emailError: null,
      })),
  })),
);

export default useFormStore;
